import { atom, useAtom } from "jotai";
import { SearchFilters } from "../models/search";
import { useCallback } from "react";
import { defaultFilterState } from "../constants/defaultFilterState";
import useUserContext from "../components/Authorization/useUserContext";

const DefaultSearchModelAtom = atom<SearchFilters | undefined>(undefined);
const InitializedAtom = atom<boolean>(false);

export const useSearchStore = () => {
  const user = useUserContext();
  const userRoles = user.selectedRoles;

  const [defaultSearch, setDefaultSearch] = useAtom(DefaultSearchModelAtom);
  const [initialized, setInitialized] = useAtom(InitializedAtom);

  const applyDefaultSearchState = useCallback(() => {
    // Only apply default state once to avoid repeated initialization
    if (initialized) return;

    // We want to turn off stack_related by default when logged in as a USLT user
    const role_override = { stack_related: !userRoles.includes("uslt_retro") };

    setDefaultSearch({ ...defaultFilterState, ...role_override });
    setInitialized(true);
  }, [initialized, userRoles, setDefaultSearch, setInitialized]);

  return {
    defaultSearch,
    setDefaultSearch,
    applyDefaultSearchState,
  };
};
